module.exports = __webpack_public_path__ + "static/media/Q3-3.76122607.jpeg";